import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useStaffList() {
  // Use toast
  const toast = useToast()

  const refStaffListTable = ref(null)

  const perPage = ref(5)
  const totalItems = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const statusFilter = ref(null)
  const branchFilter = ref(null)
  const saleRegionFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refStaffListTable.value ? refStaffListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalItems.value,
    }
  })

  const refetchData = () => {
    refStaffListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, statusFilter, branchFilter, saleRegionFilter], () => {
    refetchData()
  })

  const fetchItems = (ctx, callback) => {
    store
      .dispatch('staff/fetchAll', {
        q: searchQuery.value,
        per_page: perPage.value,
        page: currentPage.value,
        sort_by: sortBy.value,
        sort_desc: isSortDirDesc.value,
        role_id: roleFilter.value,
        status: statusFilter.value,
        branch_id: branchFilter.value,
        sale_region_id: saleRegionFilter.value,
      })
      .then(response => {
        const { staffs, total } = response.data.data

        callback(staffs)
        totalItems.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error getting staffs list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  return {
    fetchItems,
    perPage,
    currentPage,
    totalItems,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refStaffListTable,

    refetchData,

    // Extra Filters
    roleFilter,
    statusFilter,
    branchFilter,
    saleRegionFilter,
  }
}
